import axios from "axios";
import { GENERAL_URL_API } from "../../../urls";

/**
 * Creates a new super institute with provided information.
 *
 * @async
 * @param {Object} instituto - The object containing super institute information.
 * @param {string} instituto.nombre - The name of the super institute.
 * @param {number} instituto.lecturasDiarias - The number of daily readings.
 * @returns {Promise<Object>} A promise that resolves to the response data from the API.
 */
export const crearSuperInstituto = async ({ nombre, lecturasDiarias }) => {
  const fd = new FormData();
  fd.append("nombre", nombre);
  fd.append("lecturasDiarias", lecturasDiarias);

  const { data } = await axios.post(
    `${GENERAL_URL_API}/superInstituto/crearSuperInstitutos`,
    fd,
    {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return data;
}; 